/**
 * ForgotPassword Component
 * Allows users to request a password reset via email
 */

import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../constants';
import './Login.css';

interface ForgotPasswordProps {
  onBack: () => void;
  onSuccess?: () => void;
}

const ForgotPassword: React.FC<ForgotPasswordProps> = ({ onBack, onSuccess }) => {
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    if (!username.trim()) {
      setError('Bitte gib deinen Benutzernamen oder deine E-Mail-Adresse ein');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(`${API_BASE_URL}/api/auth/forgot-password`, {
        username: username.trim()
      });

      if (response.data.success) {
        setSuccess(true);
      } else {
        setError(response.data.message || 'Fehler beim Anfordern des Passwort-Resets');
      }
    } catch (err: any) {
      if (err.response?.status === 429) {
        setError('Zu viele Anfragen. Bitte versuchen Sie es später erneut.');
      } else if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError('Fehler beim Anfordern des Passwort-Resets. Bitte versuchen Sie es später erneut.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-container">
        <h1 className="login-title">Passwort vergessen?</h1>
        <p style={{ textAlign: 'center', marginBottom: '20px', color: '#666' }}>
          Gib deinen Benutzernamen oder deine E-Mail-Adresse ein. 
          Wir senden dir ein temporäres Passwort per E-Mail zu.
        </p>

        {success ? (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <div style={{ color: '#28a745', fontSize: '18px', marginBottom: '10px' }}>
              ✓ E-Mail gesendet!
            </div>
            <p style={{ color: '#666', marginBottom: '20px' }}>
              Ein temporäres Passwort wurde an deine E-Mail-Adresse gesendet.
              Bitte prüfen Sie Ihr Postfach (auch den Spam-Ordner).
            </p>
            <p style={{ color: '#ed1c24', fontWeight: 'bold', marginBottom: '20px' }}>
              Wichtig: Bitte ändern Sie das temporäre Passwort sofort nach dem Login!
            </p>
            <button
              className="login-button"
              onClick={onBack}
              style={{ marginTop: '10px' }}
            >
              Schließen
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="login-form">
            {error && (
              <div className="login-error" style={{ marginBottom: '15px' }}>
                {error}
              </div>
            )}

            <div className="login-form-group">
              <label htmlFor="forgot-username" className="login-label">
                Benutzername oder E-Mail-Adresse
              </label>
              <input
                id="forgot-username"
                type="text"
                className="login-input"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Benutzername oder E-Mail"
                disabled={loading}
                autoFocus
                autoComplete="username"
              />
            </div>

            <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
              <button
                type="button"
                className="login-button"
                onClick={onBack}
                disabled={loading}
                style={{ flex: 1, backgroundColor: '#666', borderColor: '#666' }}
              >
                Zurück
              </button>
              <button
                type="submit"
                className="login-button"
                disabled={loading || !username.trim()}
                style={{ flex: 1 }}
              >
                {loading ? 'Wird gesendet...' : 'Passwort anfordern'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;

